import PropTypes from 'prop-types';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJImageExtenderData from '../../../../config/dataConfig/FJImageExtenderData';
import styles from './FJImageExtenderRatio.module.less';
import classNames from 'classnames';
import FJLocalStore from '../../../../store/FJLocalStore';

const FJImageExtenderRatio = props => {
    const { curRatioName, changeRatio } = props;

    return (
        <div className={styles.ratio_box}>
            <div className={styles.ratio_box_title}>
                <span>{FJLocalStore._('aspect-ratio')}</span>
            </div>
            <div className={styles.ratio_list_box}>
                {FJImageExtenderData.RATIO_LIST.map(item => (
                    <FJHoverBoardGradation
                        key={item.name}
                        className={classNames(styles.ratio_item, curRatioName === item.name && styles.active)}
                        contentClassName={styles.ratio_item_content}
                        active={curRatioName === item.name}
                        borderRadius={6}
                        onClick={() => changeRatio(item)}
                    >
                        <item.icon />
                        <span>{FJLocalStore._(item.name)}</span>
                    </FJHoverBoardGradation>
                ))}
            </div>
        </div>
    );
};

FJImageExtenderRatio.propTypes = {
    curRatioName: PropTypes.string,
    changeRatio: PropTypes.func,
};

export default FJImageExtenderRatio;
